import { useCallback, useEffect } from "react";
import { useEndpointData } from "../../../utils/TableUtils";
import { ReportReceivablesSummaryService } from "../../../services/ReportReceivablesSummaryService";
import Loading from "../../shared/components/Loading";
import moment from "moment";
import { ReportReceivablesResponse } from "../../../entities/reports/ReportReceivablesSummary/ReceivablesResponse";
import Highcharts, { setOptions } from "highcharts";
import HighchartsReact from "highcharts-react-official";
import { TranslationService } from "../../../services/TranslationService";

export const RrsAveragePaymentGraph = ({ receivables }: { receivables: ReportReceivablesResponse | undefined }) => {
    const endpoint = useCallback(() => ReportReceivablesSummaryService.getAveragePayment('', moment().add(-1, "years").endOf("month").toDate()), []);
    const { loading, response } = useEndpointData(endpoint);

    useEffect(() => {
        setOptions({ exporting: { enabled: false } });
    }, [])

    if (loading || response === undefined || receivables === undefined) {
        return <Loading height={262} />;
    }

    return (
        <>
            <h5 style={{ textAlign: 'center', marginTop: 30 }}>{TranslationService.translate.DSOTrendTitle}</h5>
            <div className="card mb-2 pb-3 col justify-content-center" >
                <HighchartsReact
                    highcharts={Highcharts}
                    options={ReportReceivablesSummaryService.chartLineOptions(response.payments[0], response.payments[1], 6)} />
            </div>
        </>
    );
};